// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__bMg3X","containerItemsCenter":"Skeleton_containerItemsCenter__ws_Zk"};